import { useQuery, WatchQueryFetchPolicy } from "@apollo/client";
import { useSelector } from "react-redux";
import { WagerProfile } from "@tvg/ts-types/User";
import { getPortByBrand } from "@tvg/utils/generalUtils";
import { GET_TODAYS_TRACKS } from "../graphql/queries/TodayTracksQuery";
import { apolloOptionsTracks, getTracksProps } from "../graphql/options.graph";
import { getFavoriteTracks } from "../redux/selectors";
import { TrackFilterValueEnum } from "../types";

export default ({
  wagerProfile = getPortByBrand(),
  tracksFilter = [],
  regionsFilter = [],
  trackTypesFilter = [],
  searchQuery = "",
  onlyFeaturedTracks = false,
  maxResults = -1,
  fetchPolicy = "cache-first",
  pollInterval = 0
}: {
  wagerProfile: WagerProfile;
  tracksFilter?: Array<string>;
  regionsFilter?: Array<string>;
  trackTypesFilter?: Array<TrackFilterValueEnum>;
  searchQuery?: string;
  onlyFeaturedTracks?: boolean;
  maxResults?: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  pollInterval?: number;
}) => {
  const { loading, data } = useQuery(
    GET_TODAYS_TRACKS,
    apolloOptionsTracks({ wagerProfile, fetchPolicy, pollInterval })
  );
  const favoriteTracks = useSelector(getFavoriteTracks);

  return {
    loading,
    ...getTracksProps(
      data,
      tracksFilter || [],
      regionsFilter || [],
      searchQuery,
      onlyFeaturedTracks,
      maxResults,
      trackTypesFilter,
      favoriteTracks
    )
  };
};
